<template>
  <section class="section --dark --centered business-units__section --top w-95">
    <h2 class="title --uppercase"  v-reveal>{{ content.title }}</h2>
		<HighlightableText class="description" :text="content.description" v-reveal />
    <div class="button__group">
      <a :href="button.link" target="_blank" v-for="button in content.links" :key="button.flexKey"
         class="button --even">
        {{ button.label }}
      </a>
    </div>
    <div class="video__preview-container">
      <Image :source="content.image" class="video__preview-image"/>
      <VideoLink v-if="content.video?.length" :content="content.video[0]"/>
    </div>
    <div class="section__stats"  v-reveal>
      <div class="section__stats-block">
        <h3 class="section__stats-title">{{ content.sectorsTitle }}</h3>
        <div class="sector__list">
          <SectorCard v-for="sector in content.sectorsItems" :content="sector" :key="sector.flexKey"/>
        </div>
      </div>
      <div class="section__stats-line"></div>
      <div class="section__stats-block"  v-reveal>
        <h3 class="section__stats-title">{{ content.ontarioTitle }}</h3>
        <div class="stat__list">
          <StatCard v-for="stat in content.ontarioItems" :content="stat" :key="stat.flexKey"/>
        </div>
        <img src="@/assets/images/map.png" alt="" class="section__stats-image">
      </div>
    </div>
  </section>
</template>

<script>
import {SectorCard, StatCard} from '@/components/cards'
import {Image} from '@/components/global'
import {HasContentMixin} from '@/mixins'
import {VideoLink} from '@/components/small'
import {HighlightableText} from '@/components/blocks'


export default {
  name: 'BusinessUnitsSection',
  mixins: [HasContentMixin],
  components: {HighlightableText, Image, SectorCard, StatCard, VideoLink}
}
</script>